import { RiskReportInstanceState } from 'app/area/case-report/risk-listing/types-store';
import { ApplicationState } from 'app/types-store';

export const selectRiskReportInstanceState = (riskReportInstanceKey: string) => (state: ApplicationState): RiskReportInstanceState =>
  state?.riskReport?.instances?.[riskReportInstanceKey];

export const selectRiskReportResults = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)?.riskReportResults;

export const selectFetching = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)?.fetching;

export const selectErrorsExecuteFailed = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)?.errorsExecuteFailed;

export const selectLayoutTypeAttributes = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)
    ?.riskReportResults?.layoutModel?.layoutTypeAttributes;

export const selectFetchingOptionsDrillDownTo = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)?.fetchingOptionsDrillDownTo;

  export const selecOptionsDrillDownTo = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)?.optionsDrillDownTo;
